import { memoize } from "lodash";
import { ref } from "vue";
export const useErrorDetail = memoize(() => {
    const error = ref(null);
    const setError = (err) => {
        error.value = err;
    };
    const clearError = () => {
        error.value = null;
    };
    return {
        error,
        setError,
        clearError,
    };
});
